import { localStorageColorSchemeManager, type MantineColorScheme } from '@mantine/core';
import { COLOR_SCHEME_STORAGE_KEY as STORAGE_KEY, DEFAULT_COLOR_SCHEME as DEFAULT_SCHEME } from '@srm/ui/theme';

// Ключ цветовой схемы — per-device, а не per-user: тема — свойство экрана и освещения,
// а не аккаунта, и читать её надо до того, как известен пользователь (блокирующий скрипт
// в index.html ставит атрибут по этому же ключу до первой отрисовки, чтобы не было белой
// вспышки). Пишется только явный выбор (light | dark | auto); без ключа действует дефолт. Ключ общий с админкой
// (один origin) — @srm/ui/theme.
export const COLOR_SCHEME_STORAGE_KEY = STORAGE_KEY;

// Дефолт без сохранённого выбора — следовать системной теме. Явный выбор пользователь
// делает в настройках (секция «Оформление»). Значение обязано совпадать с дефолтом в
// блокирующем public/colorSchemeBootstrap.js, иначе Mantine перещёлкнет тему после первой отрисовки.
export const DEFAULT_COLOR_SCHEME: MantineColorScheme = DEFAULT_SCHEME;

export const colorSchemeManager = localStorageColorSchemeManager({ key: COLOR_SCHEME_STORAGE_KEY });
